import { render, staticRenderFns } from "./VxCellDate.vue?vue&type=template&id=8144424e&"
import script from "./VxCellDate.vue?vue&type=script&lang=js&"
export * from "./VxCellDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports